import {
  applySensorOffset,
  getMeshSensorColor,
  getWindowLocalCoordSystem,
  getWindowPolygonYUp,
  SPHERE_RADIUS,
} from "./utils";
import { useDispatch, useSelector } from "react-redux";
import { setSkylineSelectedSensor } from "../../redux/sensorAnalysis";
import React, { useMemo, useState } from "react";
import { SphereInstancedMesh } from "../threeDComponent/InstancedMesh";
import * as THREE from "three";

function ViewMesh({ sensors, applyOffset }) {
  const dispatch = useDispatch();
  const allWindows = useSelector((state) => state.windowData.allWindows);
  const sensorOffset = useSelector(
    (state) => state.sensorAnalysis.manualMeshing.state.sensorOffset
  );

  const [hoveredSensorId, setHoveredSensorId] = useState(null);

  const setColor = (sensor) => {
    return new THREE.Color(getMeshSensorColor(sensor.id, hoveredSensorId));
  };

  const onClick = (config) => {
    config.stopPropagation();
    const sensor = sensors[config.instanceId];
    dispatch(setSkylineSelectedSensor(sensor));
  };

  const onPointerEnter = (config) => {
    config.stopPropagation();
    const sensor = sensors[config.instanceId];
    setHoveredSensorId(sensor?.id);
  };

  const onPointerLeave = (config) => {
    config.stopPropagation();
    setHoveredSensorId(null);
  };

  const objects = useMemo(
    () =>
      sensors?.map((sensor) => {
        const window = allWindows?.find(
          (window) => window.id === sensor.surfaceId
        );
        const windowPolygonYUp = getWindowPolygonYUp(window);
        const windowCoordSystem = getWindowLocalCoordSystem(
          windowPolygonYUp?.polygon
        );
        const offsetPosition = applySensorOffset(
          sensor?.position,
          sensorOffset,
          windowCoordSystem
        );

        const position = applyOffset ? offsetPosition : sensor?.position;
        return {
          ...sensor,
          utm_x: position[0],
          utm_y: position[1],
          utm_z: position[2],
        };
      }),
    [sensors, allWindows, sensorOffset, applyOffset]
  );

  return (
    <SphereInstancedMesh
      objects={objects}
      setColor={setColor}
      groupProps={{ onClick, onPointerEnter, onPointerLeave, "rotation-x": 0 }}
      radius={SPHERE_RADIUS}
    />
  );
}

export default React.memo(ViewMesh);
